import React from 'react';
import ModernTemplate from './ModernTemplate';
import { RESUME_TEMPLATES } from '../../config/constants';
import JsonResumeThemeRenderer from './JsonResumeThemeRenderer';
import ImportCustomTemplate from './ImportCustomTemplate';

const TemplateSelector = ({ template, resume }) => {
  if (template === RESUME_TEMPLATES.IMPORT_CUSTOM) {
    return <ImportCustomTemplate resume={resume} />;
  }
  if (template && template.startsWith('json-')) {
    return <JsonResumeThemeRenderer resume={resume} templateId={template} />;
  }
  return <ModernTemplate resume={resume} />;
};

export default TemplateSelector;
